document.addEventListener('DOMContentLoaded', () => {
  const grids = document.querySelectorAll('[data-new-collection-grid]');

  grids.forEach((grid) => {
    const desktop = grid.dataset.columnsDesktop || '4';
    const tablet = grid.dataset.columnsTablet || '3';
    const mobile = grid.dataset.columnsMobile || '2';
    grid.style.setProperty('--columns-desktop', desktop);
    grid.style.setProperty('--columns-tablet', tablet);
    grid.style.setProperty('--columns-mobile', mobile);
  });

  // Filter functionality
  const filterButtons = document.querySelectorAll('.filter-btn');
  // Don't cache productItems - query fresh each time to include infinite scroll products
  const getProductItems = () => document.querySelectorAll('[data-product-filters]');
  const resetButton = document.querySelector('[data-reset-filters]');
  const filterTrack = document.querySelector('[data-filter-track]');
  const filterPrev = document.querySelector('[data-filter-prev]');
  const filterNext = document.querySelector('[data-filter-next]');
  const urlParams = new URLSearchParams(window.location.search);
  const activeFiltersParam = urlParams.get('filters'); // Use 'filters' (plural) for multiple

  // Get active filters from URL (pipe-separated) - only take first one to ensure single filter
  let activeFilters = [];
  if (activeFiltersParam) {
    const allFilters = activeFiltersParam.split('|').map(f => decodeURIComponent(f));
    // Only keep the first filter to ensure only one filter is active at a time
    activeFilters = allFilters.length > 0 ? [allFilters[0]] : [];
  }

  // Handle filter button clicks - only one filter can be selected at a time
  filterButtons.forEach((button) => {
    button.addEventListener('click', (e) => {
      e.preventDefault();
      
      const filterValue = button.dataset.filter;
      const isActive = activeFilters.length > 0 && activeFilters[0] === filterValue;

      if (isActive) {
        // If clicking the active filter, deselect it (clear all filters)
        activeFilters = [];
      } else {
        // If clicking an inactive filter, select only this one (clear others)
        activeFilters = [filterValue];
      }

      applyFiltersAndRender(true, true); // true for pushHistory, true for shouldScroll
    });
  });

  function filterProducts(activeFilterArray) {
    // Query fresh to include infinite scroll products
    const productItems = getProductItems();
    productItems.forEach((item) => {
      const filters = item.dataset.productFilters || '';
      const filterArray = filters.split('|').filter(f => f.trim() !== '');
      
      // Show product if it matches ANY of the active filters (OR logic)
      const matches = activeFilterArray.some(activeFilter => filterArray.includes(activeFilter));
      
      if (matches) {
        item.style.display = '';
      } else {
        item.style.display = 'none';
      }
    });

    updateFilterAvailability();
  }

  function showAllProducts() {
    // Query fresh to include infinite scroll products
    const productItems = getProductItems();
    productItems.forEach((item) => {
      item.style.display = '';
    });

    updateFilterAvailability();
  }

  function updateBannerVisibility() {
    // Query fresh to include infinite scroll products
    const productItems = getProductItems();
    const visibleProducts = Array.from(productItems).filter(
      (item) => item.style.display !== 'none' && !item.classList.contains('new-grid__item--promo')
    );
    
    // Get banner position from data attributes or default values
    const desktopBanner = document.querySelector('.new-grid__item--promo-desktop');
    const mobileBanner = document.querySelector('.new-grid__item--promo-mobile');
    const desktopPosition = desktopBanner?.dataset.desktopPosition ? parseInt(desktopBanner.dataset.desktopPosition) : 8;
    const mobilePosition = mobileBanner?.dataset.mobilePosition ? parseInt(mobileBanner.dataset.mobilePosition) : 4;
    
    // Hide desktop banner if visible products are less than desktop position
    if (desktopBanner) {
      if (visibleProducts.length < desktopPosition) {
        desktopBanner.style.display = 'none';
      } else {
        desktopBanner.style.display = '';
      }
    }
    
    // Hide mobile banner if visible products are less than mobile position
    if (mobileBanner) {
      if (visibleProducts.length < mobilePosition) {
        mobileBanner.style.display = 'none';
      } else {
        mobileBanner.style.display = '';
      }
    }
  }

  function updatePaginationVisibility() {
    // Pagination removed - using infinite scroll instead
    // This function kept for compatibility but does nothing
    return;
  }

  // Keep filter counts consistent across pagination by persisting server-provided totals
  function updateFilterCounts() {
    const grid = document.querySelector('[data-new-collection-grid]');
    const collectionHandle = grid?.dataset.collectionHandle || 'collection';
    const storageKey = `filterCounts:${collectionHandle}`;

    // Try to load previously stored counts (from page 1)
    let storedCounts = {};
    try {
      storedCounts = JSON.parse(sessionStorage.getItem(storageKey)) || {};
    } catch (e) {
      storedCounts = {};
    }

    const countsToStore = {};

    filterButtons.forEach((button) => {
      const filterValue = button.dataset.filter;
      const countSpan = button.querySelector('.filter-count');
      const serverCount = button.dataset.filterCount;

      // Prefer server-provided count; fall back to stored counts if server count is missing/zero
      let finalCount = serverCount;
      const parsedServerCount = parseInt(serverCount, 10);
      if (Number.isNaN(parsedServerCount) || parsedServerCount === 0) {
        if (storedCounts[filterValue] !== undefined) {
          finalCount = storedCounts[filterValue];
        }
      }

      if (countSpan && finalCount !== undefined) {
        countSpan.textContent = `(${finalCount})`;
      }

      // Save non-zero counts for reuse on other pages
      const parsedFinal = parseInt(finalCount, 10);
      if (!Number.isNaN(parsedFinal) && parsedFinal > 0) {
        countsToStore[filterValue] = parsedFinal;
      }
    });

    try {
      sessionStorage.setItem(storageKey, JSON.stringify(countsToStore));
    } catch (e) {
      // ignore storage errors
    }
  }

  // Update displayed counts using loaded products when they exceed server-provided totals
  function updateCountsWithLoadedProducts() {
    const productItems = getProductItems();
    const loadedCounts = {};

    Array.from(productItems).forEach((item) => {
      const filters = item.dataset.productFilters || '';
      filters
        .split('|')
        .map(f => f.trim())
        .filter(Boolean)
        .forEach((f) => {
          loadedCounts[f] = (loadedCounts[f] || 0) + 1;
        });
    });

    filterButtons.forEach((btn) => {
      const filterValue = btn.dataset.filter;
      const serverCount = parseInt(btn.dataset.filterCount, 10) || 0;
      const loaded = loadedCounts[filterValue] || 0;
      const final = Math.max(serverCount, loaded);
      const countSpan = btn.querySelector('.filter-count');
      if (countSpan) countSpan.textContent = `(${final})`;
    });
  }

  function updateFilterAvailability() {
    // When filters are active, dim options that don't exist in the current result set
    // But keep all filters enabled - only the clicked one should be active (bg-black)
    filterButtons.forEach((btn) => {
      btn.classList.remove('filter-btn--disabled');
      btn.style.opacity = '';
      btn.style.pointerEvents = '';
    });

    updateResetButton();
  }

  function updateResetButton() {
    if (!resetButton) return;
    resetButton.style.display = activeFilters.length > 0 ? 'inline-flex' : 'none';
  }

  function updateFilterArrows() {
    if (!filterTrack) return;

    // Only show arrows on mobile/tablet per design
    const isMobile = window.innerWidth <= 1023;
    if (!isMobile) {
      if (filterPrev) filterPrev.style.display = 'none';
      if (filterNext) filterNext.style.display = 'none';
      return;
    }

    const maxScroll = filterTrack.scrollWidth - filterTrack.clientWidth;
    const current = filterTrack.scrollLeft;
    const hasOverflow = maxScroll > 4;
    const hasPrev = hasOverflow && current > 4;
    const hasNext = hasOverflow && current < maxScroll - 4;

    if (filterPrev) {
      filterPrev.disabled = !hasPrev;
      filterPrev.classList.toggle('is-disabled', !hasPrev);
      filterPrev.style.display = hasPrev ? 'inline-flex' : 'none';
    }
    if (filterNext) {
      filterNext.disabled = !hasNext;
      filterNext.classList.toggle('is-disabled', !hasNext);
      filterNext.style.display = hasNext ? 'inline-flex' : 'none';
    }
  }

  function scrollFilters(direction) {
    if (!filterTrack) return;
    const distance = filterTrack.clientWidth * 0.75 || 200;
    filterTrack.scrollBy({
      left: distance * direction,
      behavior: 'smooth',
    });
    setTimeout(updateFilterArrows, 250);
  }

  if (filterPrev) {
    filterPrev.addEventListener('click', (e) => {
      e.preventDefault();
      scrollFilters(-1);
    });
  }

  if (filterNext) {
    filterNext.addEventListener('click', (e) => {
      e.preventDefault();
      scrollFilters(1);
    });
  }

  if (filterTrack) {
    filterTrack.addEventListener('scroll', updateFilterArrows, { passive: true });
  }

  function updateURLFromFilters(pushState = false) {
    const newUrl = new URL(window.location);
    newUrl.searchParams.delete('page');

    // Ensure only one filter is in the URL
    const activeFilter = activeFilters.length > 0 ? activeFilters[0] : null;
    if (activeFilter) {
      newUrl.searchParams.set('filters', encodeURIComponent(activeFilter));
    } else {
      newUrl.searchParams.delete('filters');
    }

    if (pushState) {
      window.history.pushState({}, '', newUrl.toString());
    } else {
      window.history.replaceState({}, '', newUrl.toString());
    }
  }

  function syncButtonsFromActiveFilters() {
    // Ensure only one filter is active at a time
    const activeFilter = activeFilters.length > 0 ? activeFilters[0] : null;
    
    filterButtons.forEach((btn) => {
      btn.classList.remove('bg-black', 'text-white');
      btn.classList.add('bg-gray-100');

      const closeIcon = Array.from(btn.querySelectorAll('span')).find(
        (span) => span.textContent.trim() === '✕'
      );
      if (closeIcon) closeIcon.remove();

      const filterValue = btn.dataset.filter;
      // Only mark as active if it's the single active filter
      if (activeFilter && activeFilter === filterValue) {
        btn.classList.remove('bg-gray-100');
        btn.classList.add('bg-black', 'text-white');
        const closeIconNew = document.createElement('span');
        closeIconNew.textContent = '✕';
        closeIconNew.style.marginLeft = '4px';
        btn.appendChild(closeIconNew);
      }
    });
  }

  // Ensure the filters element does not remain `position: sticky` when there are no filter buttons
  function updateFiltersStickyState() {
    const el = document.querySelector('.new-collection-grid__filters');
    if (!el) return;
    const btns = el.querySelectorAll('.filter-btn');
    const hasAnyBtn = btns.length > 0;
    if (!hasAnyBtn) {
      el.classList.remove('is-sticky');
      el.style.position = 'revert';
    } else {
      // clear inline override so CSS can control sticky behavior
      el.style.position = '';
    }
  }

  function applyFiltersAndRender(pushHistory = false, shouldScroll = false) {
    syncButtonsFromActiveFilters();

    if (activeFilters.length > 0) {
      filterProducts(activeFilters);
    } else {
      showAllProducts();
    }

    updateBannerVisibility();
    updatePaginationVisibility();
    updateFilterAvailability();
    updateResetButton();
    updateURLFromFilters(pushHistory);
    updateFilterArrows();

    // Ensure filters don't remain sticky when there are no buttons
    try { updateFiltersStickyState(); } catch (e) { /* ignore */ }

    // Scroll to grid section after applying filters (only when user actively clicks)
    if (shouldScroll) {
      scrollToGridSection();
    }
  }

  function scrollToGridSection() {
    // Find the grid inner section
    const gridInner = document.querySelector('.new-collection-grid__inner');
    if (!gridInner) return;

    // Calculate the offset including sticky header and filters
    const announcementHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--announcement-bar-height')) || 0;
    const headerHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 0;
    const filtersElement = document.querySelector('.new-collection-grid__filters');
    const filtersHeight = filtersElement ? filtersElement.offsetHeight : 0;
    
    // Total offset to account for sticky elements
    const totalOffset = announcementHeight + headerHeight + filtersHeight;
    
    // Get the position of the grid
    const gridRect = gridInner.getBoundingClientRect();
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const targetPosition = gridRect.top + scrollTop - totalOffset - 20; // 20px extra spacing
    
    // Smoothly scroll to the grid section
    window.scrollTo({
      top: targetPosition,
      behavior: 'smooth'
    });
  }

  // Handle browser back/forward buttons
  window.addEventListener('popstate', (e) => {
    const urlParams = new URLSearchParams(window.location.search);
    const activeFiltersParam = urlParams.get('filters');
    
    // Get active filters from URL - only take first one to ensure single filter
    activeFilters = [];
    if (activeFiltersParam) {
      const allFilters = activeFiltersParam.split('|').map(f => decodeURIComponent(f));
      // Only keep the first filter to ensure only one filter is active at a time
      activeFilters = allFilters.length > 0 ? [allFilters[0]] : [];
    }

    applyFiltersAndRender(false);
  });

  // Initial render based on URL filters
  applyFiltersAndRender(false);
  updateFilterCounts();
  // If currently loaded products exceed server counts, show the larger value
  if (typeof updateCountsWithLoadedProducts === 'function') updateCountsWithLoadedProducts();
  updateBannerVisibility();
  updatePaginationVisibility();
  updateFilterArrows();

  if (resetButton) {
    resetButton.addEventListener('click', (e) => {
      e.preventDefault();
      activeFilters = [];
      applyFiltersAndRender(true, true); // true for pushHistory, true for shouldScroll
    });
  }

  // Update header height CSS variable for sticky positioning
  const updateHeaderHeight = () => {
    try {
      const headerWrapper = document.querySelector('.section-header-new');
      if (headerWrapper) {
        const height = headerWrapper.offsetHeight;
        document.documentElement.style.setProperty('--header-height', `${height}px`);
      }
    } catch (error) {
      console.warn('Error updating header height:', error);
    }
  };

  // Set header height on load and resize
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateHeaderHeight);
  } else {
    updateHeaderHeight();
  }

  // Update on window resize with debouncing
  let resizeTimeout;
  window.addEventListener('resize', () => {
    updateFilterArrows();
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(updateHeaderHeight, 100);
  }, { passive: true });

  // Update after delays to ensure header is fully rendered
  setTimeout(updateHeaderHeight, 50);
  setTimeout(updateHeaderHeight, 200);

  // Sticky filters functionality
  const filtersElement = document.querySelector('.new-collection-grid__filters');
  if (filtersElement) {
    const checkSticky = () => {
      // If there are no filter buttons or none visible, revert sticky positioning
      const btns = filtersElement.querySelectorAll('.filter-btn');
      const hasVisibleBtn = Array.from(btns).some(b => b.offsetParent !== null);
      if (btns.length === 0 || !hasVisibleBtn) {
        filtersElement.classList.remove('is-sticky');
        filtersElement.style.position = 'revert';
        return;
      } else {
        // clear any inline override so CSS can manage sticky
        filtersElement.style.position = '';
      }

      const rect = filtersElement.getBoundingClientRect();
      // Get header and announcement heights
      const announcementHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--announcement-bar-height')) || 0;
      const headerHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 0;
      const stickyTop = announcementHeight + headerHeight;
      
      // If element's top position matches the sticky position (or very close), it's sticky
      if (Math.abs(rect.top - stickyTop) <= 1 && window.scrollY > stickyTop) {
        filtersElement.classList.add('is-sticky');
      } else {
        filtersElement.classList.remove('is-sticky');
      }
    };

    // Check on scroll
    let ticking = false;
    window.addEventListener('scroll', () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          checkSticky();
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });

    // Initial check after header height is set
    setTimeout(() => {
      updateHeaderHeight();
      checkSticky();
    }, 300);
  }

  // Infinite Scroll Implementation
  const infiniteScrollInit = () => {
    const grid = document.querySelector('[data-new-collection-grid]');
    if (!grid) return;

    let isLoading = false;
    let hasMorePages = true;
    let nextPageUrl = null;
    let observer = null;
    
    // Get initial next page URL from hidden element
    const triggerElement = document.querySelector('[data-infinite-scroll-next-url]');
    if (triggerElement) {
      nextPageUrl = triggerElement.dataset.infiniteScrollNextUrl;
    }
    
    // Setup observer function
    const setupScrollObserver = () => {
      // Find the last product items (excluding promo banners)
      const allProducts = Array.from(grid.querySelectorAll('.new-grid__item')).filter(item => {
        return !item.classList.contains('new-grid__item--promo-desktop') && 
               !item.classList.contains('new-grid__item--promo-mobile');
      });
      
      if (allProducts.length === 0) return;
      
      // Use the last 2 products as trigger points
      const triggerProducts = allProducts.slice(-2);
      
      // Clean up existing observer
      if (observer) {
        observer.disconnect();
      }
      
      // Create intersection observer
      observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          // When last product enters viewport, load next page
          if (entry.isIntersecting && hasMorePages && !isLoading && nextPageUrl) {
            loadNextPage();
          }
        });
      }, {
        root: null, // viewport
        rootMargin: '100px', // Trigger 100px before product enters viewport
        threshold: 0.01 // Trigger when just 1% visible
      });
      
      // Observe the last products
      triggerProducts.forEach((product) => {
        observer.observe(product);
      });
    };

    const loadNextPage = async () => {
      if (isLoading || !hasMorePages || !nextPageUrl) {
        return;
      }

      isLoading = true;
      
      try {
        // Preserve filter parameters in URL if they exist
        let urlToFetch = nextPageUrl;
        const activeFilter = activeFilters.length > 0 ? activeFilters[0] : null;
        if (activeFilter) {
          const url = new URL(nextPageUrl, window.location.origin);
          url.searchParams.set('filters', encodeURIComponent(activeFilter));
          urlToFetch = url.pathname + url.search;
        }
        
        // Fetch next page
        const response = await fetch(urlToFetch);
        if (!response.ok) throw new Error('Failed to load next page');
        
        const html = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        
        // Find products in the fetched HTML
        const fetchedGrid = doc.querySelector('[data-new-collection-grid]');
        if (!fetchedGrid) {
          hasMorePages = false;
          return;
        }

        const newProducts = fetchedGrid.querySelectorAll('.new-grid__item');
        if (newProducts.length === 0) {
          hasMorePages = false;
          return;
        }

        // Filter out promo banners - they should only appear once on first page
        const newProductsWithoutBanners = Array.from(newProducts).filter((product) => {
          return !product.classList.contains('new-grid__item--promo-desktop') && 
                 !product.classList.contains('new-grid__item--promo-mobile');
        });

        if (newProductsWithoutBanners.length === 0) {
          hasMorePages = false;
          return;
        }

        // Append new products (without banners) to current grid
        newProductsWithoutBanners.forEach((product) => {
          grid.appendChild(product);
        });

        // Update next page URL from fetched HTML
        const newTriggerElement = doc.querySelector('[data-infinite-scroll-next-url]');
        if (newTriggerElement) {
          nextPageUrl = newTriggerElement.dataset.infiniteScrollNextUrl;
          // Update the trigger element in current page
          if (triggerElement) {
            triggerElement.dataset.infiniteScrollNextUrl = nextPageUrl;
          }
        } else {
          hasMorePages = false;
        }

        // Update displayed counts if loaded products increase any filter totals
        if (typeof updateCountsWithLoadedProducts === 'function') updateCountsWithLoadedProducts();

        // If filters are active, apply them to newly loaded products
        if (activeFilters.length > 0) {
          // Apply filters to newly loaded products using the filter function
          filterProducts(activeFilters);
          // Update filter availability with new products
          updateFilterAvailability();
          updateBannerVisibility();
        }

        // Re-initialize observer with new products after loading
        setTimeout(setupScrollObserver, 300);

        // Re-initialize any JS needed for new products (quick-add, etc.)
        // The existing event listeners on document should handle new forms automatically
        
      } catch (error) {
        console.warn('Error loading next page:', error);
        hasMorePages = false;
      } finally {
        isLoading = false;
      }
    };

    // Initial setup after a short delay to ensure DOM is ready
    setTimeout(setupScrollObserver, 500);
  };

  // Initialize infinite scroll after DOM is ready
  infiniteScrollInit();

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('.new-grid-card__product-form');
    if (!form) return;

    const enableAjax = form.querySelector('[data-ajax-add="true"]');
    if (!enableAjax) return;

    event.preventDefault();
    const button = form.querySelector('button[type="submit"]');
    const variantInput = form.querySelector('input[name="id"]');
    if (!button || !variantInput) return;

    button.classList.add('is-loading');

    try {
      const payload = {
        id: variantInput.value,
        quantity: 1,
      };

      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        throw new Error('Add to cart failed');
      }

      button.classList.add('is-success');
      document.body.dispatchEvent(new CustomEvent('cart:refresh'));

      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && typeof cartDrawer.open === 'function') {
        cartDrawer.open();
      }
    } catch (error) {
      button.classList.add('is-error');
      console.error(error);
    } finally {
      button.classList.remove('is-loading');
      setTimeout(() => {
        button.classList.remove('is-success');
        button.classList.remove('is-error');
      }, 1200);
    }
  });

  // Prevent Judge.me badge links from redirecting to footer or external pages
  document.addEventListener('click', (event) => {
    // Check if the click is on or within a Judge.me badge
    const badgeElement = event.target.closest('.jdgm-preview-badge, .jdgm-widget');
    if (badgeElement) {
      // Check if the clicked element is a link
      const clickedLink = event.target.closest('a');
      if (clickedLink) {
        event.preventDefault();
        event.stopPropagation();
        
        // Optionally, scroll to reviews section if it exists on the page
        // or just prevent the default action
        return false;
      }
    }
  }, true); // Use capture phase to catch the event early
});

